import React, { useEffect, useState } from 'react';
import ModalComponent from '../utils/modal';
import { Form } from 'react-bootstrap';
import { Editor } from '@tiptap/react';
import { getAudioAutoplay, modifyAudioAutoplay } from '../editor/editorExtensions/utilityFunctions';
import { hideLinkInfoPopup } from './showLinkInfoPopup';

interface AudioOptionsProps {
  editor: Editor;
}

const AudioOptions = (props: Readonly<AudioOptionsProps>) => {
  const [showModal, setShowModal] = useState(false);
  const [autoplay, setAutoplay] = useState(false);

  useEffect(() => {
    setAutoplay(getAudioAutoplay(props.editor));
  }, [props]);

  const handleSave = () => {
    modifyAudioAutoplay(autoplay, props.editor);
    handleClose();
  };

  const handleClose = () => {
    setShowModal(false);
    hideLinkInfoPopup();
  };

  return (
    <>
      <button
        type='button'
        onClick={() => {
          setShowModal(true);
        }}
        className='p-1'
        style={{
          backgroundColor: '#ffffff',
          border: '1px solid #d8d8d8',
          borderRadius: '4px',
        }}
      >
        Audio Options
      </button>
      <ModalComponent
        show={showModal}
        handleCancel={handleClose}
        modalDetails={{
          title: 'Audio Options',
          body: (
            <div className='d-flex pt-2'>
              <Form.Label htmlFor='lint-audio-autoplay-option' className='links-tab-label'>
                <input
                  onClick={(e) => e.stopPropagation()}
                  type='checkbox'
                  id='lint-audio-autoplay-option'
                  name='lint-audio-autoplay-option'
                  checked={autoplay}
                  onChange={() => setAutoplay(!autoplay)}
                />
                <span
                  className='px-2'
                  style={{
                    fontSize: '16px',
                  }}
                >
                  Autoplay
                </span>
              </Form.Label>
            </div>
          ),
        }}
        confirmButton={{
          label: 'Save',
          disabled: false,
          handleConfirm: handleSave,
        }}
        cancelButton={{
          label: 'Cancel',
        }}
      />
    </>
  );
};

export default AudioOptions;
